import axios from 'axios';
import { protocol } from '../../config/Constant';

export const getRoomList = (IP) => {
  return async dispatch => {
    try {
      const response = await axios.put(
        IP.startsWith("http") ?
        `${IP}/Connector/rest/location/fetch-all`
        : protocol == "http" ? `http://${IP}:8080/Connector/rest/location/fetch-all` : `https://${IP}:8443/Connector/rest/location/fetch-all`,
        {},
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      if (response && response.data && response.data.payload) {
        console.log("Room list response:", response.data.payload);
        return { status: "SUCCESS", data: response.data.payload };
      } else {
        return { status: "ERROR", message: "No rooms found" };
      }
    } catch (error) {
      console.log("Api failed with the status code:", error);
      return { status: "ERROR", message: `Failed to fetch room list: ${error.message}`};
    }
  };
};
